import { CellDoubleClickedEvent } from '@ag-grid-community/core';
import { Component, EventEmitter, Inject, OnInit, Optional, Output } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions, GridRow } from '@app/core/components/grid/grid.types';
import { StateDialogContext, TT_STATE_DIALOG } from '@app/modal/state-modal/state-modal.component';

@GridModalComponent('ultrasonicclasses')
@Component({
    selector: 'tt-ultra-sonic-classes',
    templateUrl: './ultra-sonic-classes.component.html',
    styleUrls: ['./ultra-sonic-classes.component.css'],
})
export class UltraSonicClassesComponent implements OnInit {
    public grid?: GridOptions;

    @Output()
    public submit = new EventEmitter<GridRow>();

    constructor(@Optional() @Inject(TT_STATE_DIALOG) private stateDialog: StateDialogContext) {
        this.initFromDialog(stateDialog);
    }

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_materialgrades').setLoadDataFunction({ method: 3905 });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    public onDoubleClick(event: CellDoubleClickedEvent) {
        this.submit.emit(event.node.data);
    }

    private async init() {
        this.readGrid();
    }

    ngOnInit(): void {
        this.readGrid();
    }

    private initFromDialog(state?: StateDialogContext) {
        if (!!state) {
            state.setSize({ width: 'min(160rem, 95vw)', height: 'min(95vh, 60rem)' });
            this.submit.subscribe({ next: (value: GridRow) => state.close(value) });
            state.setHeading('p2_m_ultrasonicclasses', true);
        }
    }
}
